import { z } from 'zod'

export const campeonatoFormSchema = z.object({
  idclube: z.number({ required_error: 'Clube obrigatorio' }).int().positive('Clube obrigatorio'),
  descricao: z.string().min(1, 'Descricao obrigatoria').max(200),
  numero_etapa: z.number().int().min(1).default(1),
  temporada: z.number({ required_error: 'Temporada obrigatoria' }).int().min(2000),
  flag_soma_etapa: z.boolean().default(false),
  flag_calcula_somatoria_auto: z.boolean().default(false),
  flag_descarta_etapa: z.boolean().default(false),
  numero_descarte_etapa: z.number().int().min(0).default(0),
  flag_obriga_arma_inscricao: z.boolean().default(false),
  flag_permite_reinscricao: z.boolean().default(false),
  numero_max_inscricao: z.number().int().min(1).default(1),
})

export const regraValorSchema = z.object({
  operador: z.enum(['=', '>', '>=', '<', '<=']),
  quantidade: z.number().int().min(1),
  valor: z.number().min(0),
  ordem_aplicacao: z.number().int().min(1),
})

export type CampeonatoFormData = z.infer<typeof campeonatoFormSchema>
export type RegraValorFormData = z.infer<typeof regraValorSchema>
